import { CustomCellEditorProps } from "@ag-grid-community/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { SimpleMoneyInput } from "shared/components/input/text/SimpleMoneyInput";
import { useMaybernTableCellEditorProps } from "shared/components/table/maybern/MaybernTableCellEditor";

export const MaybernTableAmountCellEditor: React.FC<CustomCellEditorProps> = (
  props,
) => {
  const { t } = useTranslation(["common"]);

  const { inputRef, value, onValueChange, error } =
    useMaybernTableCellEditorProps(props);

  return (
    <SimpleMoneyInput
      ref={inputRef}
      variant="simple-table"
      placeholder={t("common:enterAmount")}
      showCurrencyIcon={false}
      showCurrencyPrefix={false}
      allowNegative={true}
      value={value}
      onChangeValue={onValueChange}
      error={error}
    />
  );
};
